{
  "v6.exploitation.annuler": "Cancel",
  "v6.exploitation.bilan.a_rediger": "Review to be written.",
  "v6.exploitation.bilan.a_transmettre": "Review published: hand the incident over to the contributor in charge of follow-up.",
  "v6.exploitation.bilan.actions_vide": "No follow-up action.",
  "v6.exploitation.bilan.autre_personne": "Publication falls to someone other than the review’s author.",
  "v6.exploitation.bilan.brouillon": "Draft by {{auteur}}, changed {{date}}.",
  "v6.exploitation.bilan.brouillon_ok": "Draft saved.",
  "v6.exploitation.bilan.brouillon_requis": "Save a draft first.",
  "v6.exploitation.bilan.creer_action": "Create a follow-up action",
  "v6.exploitation.bilan.deja_publie": "Review already published.",
  "v6.exploitation.bilan.echec": "The action did not complete.",
  "v6.exploitation.bilan.enregistrer": "Save the draft",
  "v6.exploitation.bilan.incident_non_resolu": "Incident not resolved.",
  "v6.exploitation.bilan.incident_resolu": "Incident resolved.",
  "v6.exploitation.bilan.lecture_seule": "Review published or incident closed: read only.",
  "v6.exploitation.bilan.ouvrir_element": "Item no. {{id}}",
  "v6.exploitation.bilan.personnes_citees": "People named: {{noms}}. A blameless review describes facts, not people.",
  "v6.exploitation.bilan.publication": "Publication",
  "v6.exploitation.bilan.publie_ok": "Review published: the incident can be closed.",
  "v6.exploitation.bilan.publie_par": "Published by {{personne}} on {{date}}.",
  "v6.exploitation.bilan.publier": "Publish the review",
  "v6.exploitation.bilan.relais": "Creating a follow-up action is reserved to a contributor holding “Create and edit backlog items”.",
  "v6.exploitation.bilan.relecture_requise": "Tick the review check before publishing.",
  "v6.exploitation.bilan.relu": "I have read the whole review",
  "v6.exploitation.bilan.resolution_prealable": "The incident must be resolved before publication.",
  "v6.exploitation.bilan.resume_cause_requis": "The summary and the cause are required.",
  "v6.exploitation.bilan.rubrique.contributing_factors": "Contributing factors",
  "v6.exploitation.bilan.rubrique.lessons": "Lessons",
  "v6.exploitation.bilan.rubrique.root_cause": "Cause",
  "v6.exploitation.bilan.rubrique.summary": "Summary",
  "v6.exploitation.bilan.rubrique.what_went_well": "What went well",
  "v6.exploitation.bilan.sans_notification": "No notification is sent automatically.",
  "v6.exploitation.bilan.suivi": "Follow-up",
  "v6.exploitation.bilan.titre": "Blameless incident review",
  "v6.exploitation.bilan.trouver_contributeur": "Find a contributor for follow-up",
  "v6.exploitation.champ.deploiement": "Deployment",
  "v6.exploitation.champ.environnement": "Environment",
  "v6.exploitation.champ.environnements": "the project’s environments",
  "v6.exploitation.champ.responsable": "Owner",
  "v6.exploitation.champ.version": "Version",
  "v6.exploitation.choisir": "— choose —",
  "v6.exploitation.code.ACCESS_DENIED": "You must be an active project member for this action.",
  "v6.exploitation.code.CONTEXTE_INCOMPLET": "This project cannot be found or is outside your organisation.",
  "v6.exploitation.code.DEPLOYMENT_NOT_FOUND": "This deployment cannot be found in this project.",
  "v6.exploitation.code.DROIT_NON_TENU": "This action requires a right you do not hold on this project.",
  "v6.exploitation.code.ENVIRONMENT_NOT_FOUND": "This environment cannot be found in this project.",
  "v6.exploitation.code.INCIDENT_CLOSED_IMMUTABLE": "This incident is closed: it can no longer be changed.",
  "v6.exploitation.code.INCIDENT_DEFECT_ALREADY_LINKED": "This defect is already linked to the incident.",
  "v6.exploitation.code.INCIDENT_DEFECT_OUT_OF_SCOPE": "This defect does not exist in this project.",
  "v6.exploitation.code.INCIDENT_DEPLOYMENT_OUT_OF_SCOPE": "This deployment does not concern the chosen environment.",
  "v6.exploitation.code.INCIDENT_ENVIRONMENT_OUT_OF_SCOPE": "This environment does not belong to this project.",
  "v6.exploitation.code.INCIDENT_FIELDS_INVALID": "An incident field is missing or out of bounds.",
  "v6.exploitation.code.INCIDENT_POSTMORTEM_INCOMPLETE": "The review needs at least a summary and a cause.",
  "v6.exploitation.code.INCIDENT_POSTMORTEM_PUBLISHED": "The review is published: it is no longer rewritten.",
  "v6.exploitation.code.INCIDENT_POSTMORTEM_REQUIRED": "Closing requires a published review.",
  "v6.exploitation.code.INCIDENT_POSTMORTEM_REQUIRES_RESOLVED": "The incident must be resolved before the review is published.",
  "v6.exploitation.code.INCIDENT_RELEASE_OUT_OF_SCOPE": "This version does not belong to this project.",
  "v6.exploitation.code.INCIDENT_REOPEN_REASON_REQUIRED": "Reopening requires a reason.",
  "v6.exploitation.code.INCIDENT_RESOLUTION_REQUIRED": "Resolving requires a description of the recovery.",
  "v6.exploitation.code.INCIDENT_RESPONSIBLE_NOT_MEMBER": "The owner must be a project member.",
  "v6.exploitation.code.INCIDENT_ROLE_REQUIRED": "Your project role does not allow acting on incidents.",
  "v6.exploitation.code.INCIDENT_ROLLBACK_NOT_A_ROLLBACK": "The deployment cited is not a rollback.",
  "v6.exploitation.code.INCIDENT_STARTED_AFTER_DECLARATION": "The start cannot be later than the declaration.",
  "v6.exploitation.code.INCIDENT_STARTED_AT_INVALID": "The date entered is invalid or in the future.",
  "v6.exploitation.code.INCIDENT_TRANSITION_REFUSED": "This state change is not allowed from the current state.",
  "v6.exploitation.code.QL_DOCUMENTATION_EN_COURS": "A regeneration is already running: try again in a moment.",
  "v6.exploitation.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v6.exploitation.code.SERVICE_OBJECTIVE_ENVIRONMENT_OUT_OF_SCOPE": "This environment does not belong to this project.",
  "v6.exploitation.code.SERVICE_OBJECTIVE_FIELDS_INVALID": "A commitment field is invalid or out of bounds.",
  "v6.exploitation.code.SERVICE_OBJECTIVE_INDICATOR_IMMUTABLE": "A commitment’s indicator does not change after it is declared.",
  "v6.exploitation.code.SERVICE_OBJECTIVE_NAME_TAKEN": "This commitment name is already used in this project.",
  "v6.exploitation.code.SERVICE_OBJECTIVE_ROLE_REQUIRED": "Your project role does not allow managing commitments.",
  "v6.exploitation.code.VALIDATION_ERROR": "The request is incomplete or out of bounds.",
  "v6.exploitation.code.VALIDATION_PAR_UN_TIERS": "The review must be published by someone other than its author.",
  "v6.exploitation.code.VERSION_CONFLICT": "The object changed meanwhile: reload it before acting.",
  "v6.exploitation.declarer.changement_reference": "Differs from the observed environment ({{observe}}).",
  "v6.exploitation.declarer.consomme_marge": "An outage consumes the environment’s commitment budget.",
  "v6.exploitation.declarer.debut": "Start (local time)",
  "v6.exploitation.declarer.debut_aide": "Time zone: {{fuseau}}. Empty: now.",
  "v6.exploitation.declarer.debut_invalide": "Unreadable start date.",
  "v6.exploitation.declarer.debut_observe": "Suggested from the observed measurement; editable.",
  "v6.exploitation.declarer.declare": "Incident declared.",
  "v6.exploitation.declarer.declarer": "Declare the incident",
  "v6.exploitation.declarer.echec": "The declaration did not complete; your input is kept.",
  "v6.exploitation.declarer.env_inconnu": "Observed environment “{{valeur}}” unknown to the project: choose it explicitly.",
  "v6.exploitation.declarer.environnement_requis": "Choose the affected environment.",
  "v6.exploitation.declarer.moi": "Me",
  "v6.exploitation.declarer.nature": "Impact type",
  "v6.exploitation.declarer.observe": "Observed in monitoring: {{environnement}}, version {{version}}, measured {{mesure}}.",
  "v6.exploitation.declarer.options": "the project’s environments, versions and members",
  "v6.exploitation.declarer.origine_supervision": "Opened from monitoring: the observed context goes with the declaration.",
  "v6.exploitation.declarer.responsable_aide": "A named project member; you by default.",
  "v6.exploitation.declarer.sans_environnement": "No environment is declared: declare one before declaring an incident.",
  "v6.exploitation.declarer.sans_mesure": "no dated measurement",
  "v6.exploitation.declarer.sans_observation": "Declaration without a monitoring observation: fill in the affected environment.",
  "v6.exploitation.declarer.titre": "Declare an incident",
  "v6.exploitation.declarer.titre_champ": "Title",
  "v6.exploitation.declarer.vecu": "What users experience",
  "v6.exploitation.declarer.vecu_aide": "Describe the impact as experienced, without blaming anyone.",
  "v6.exploitation.declarer.vecu_requis": "Describe what users experience and give a title.",
  "v6.exploitation.declarer.version_inconnue": "Observed version “{{valeur}}” unknown to the catalogue: it must be filled in explicitly.",
  "v6.exploitation.doc.auteur": "Generated by",
  "v6.exploitation.doc.composee": "Contents composed on {{date}} from project data.",
  "v6.exploitation.doc.documents_version": "Documents of a version",
  "v6.exploitation.doc.echec": "The regeneration did not complete.",
  "v6.exploitation.doc.generee_le": "Generation",
  "v6.exploitation.doc.introuvable": "This page is not generated: regenerate the project documentation.",
  "v6.exploitation.doc.page": "the page",
  "v6.exploitation.doc.page_requise": "The page must be read before downloading.",
  "v6.exploitation.doc.page_titre": "Documentation page",
  "v6.exploitation.doc.page_vide": "This page is empty.",
  "v6.exploitation.doc.pages": "Documentation pages",
  "v6.exploitation.doc.perimee": "stale: missing from the last regeneration",
  "v6.exploitation.doc.regeneree": "Documentation regenerated: {{n}} page(s).",
  "v6.exploitation.doc.regenerer": "Regenerate the documentation",
  "v6.exploitation.doc.retour": "Back to the documentation",
  "v6.exploitation.doc.revision": "Source revision",
  "v6.exploitation.doc.sans_page": "No page is designated: open it from the project documentation.",
  "v6.exploitation.doc.sans_titre": "Untitled section",
  "v6.exploitation.doc.stat.decisions": "decisions",
  "v6.exploitation.doc.stat.requirements": "requirements",
  "v6.exploitation.doc.stat.sprints": "sprints",
  "v6.exploitation.doc.statistique": "{{cle}}: {{n}}",
  "v6.exploitation.doc.statistiques": "Statistics",
  "v6.exploitation.doc.telecharge": "Markdown downloaded (fingerprint {{empreinte}}).",
  "v6.exploitation.doc.telechargement_echec": "The download did not complete.",
  "v6.exploitation.doc.telecharger": "Download the Markdown",
  "v6.exploitation.doc.titre": "Project documentation",
  "v6.exploitation.doc.vide": "This project’s documentation has no page yet.",
  "v6.exploitation.ecran_non_realise": "“{{ecran}}” leads to a screen that is not built yet: it comes with wave {{vague}}.",
  "v6.exploitation.engagement.actif": "Active",
  "v6.exploitation.engagement.atteint": "Achieved over the window: {{valeur}}",
  "v6.exploitation.engagement.avertir_seulement": "An alert warns; it blocks nothing.",
  "v6.exploitation.engagement.cible": "Target (%)",
  "v6.exploitation.engagement.cible_aide": "Strictly between 0 and 100, for example 99.5.",
  "v6.exploitation.engagement.cible_invalide": "The target is a percentage strictly between 0 and 100.",
  "v6.exploitation.engagement.consomme": "{{statut}} · {{severite}} · {{duree}} counted",
  "v6.exploitation.engagement.declare": "Commitment declared.",
  "v6.exploitation.engagement.declarer": "Declare the commitment",
  "v6.exploitation.engagement.declarer_titre": "Declare a service commitment",
  "v6.exploitation.engagement.definition": "Definition and alerts",
  "v6.exploitation.engagement.description": "Description",
  "v6.exploitation.engagement.destinataires": "Alert recipients",
  "v6.exploitation.engagement.echec": "The action did not complete; your input is kept.",
  "v6.exploitation.engagement.enregistre": "Commitment saved.",
  "v6.exploitation.engagement.enregistrer": "Save the commitment",
  "v6.exploitation.engagement.environnement_requis": "Choose the measured environment.",
  "v6.exploitation.engagement.fenetres": "Alerts computed over the long window ({{jours}} days) and a short window.",
  "v6.exploitation.engagement.formule": "Budget = (100% − {{cible}}) × {{total}} {{unite}} = {{marge}}; consumed {{consomme}}, remaining {{reste}} ({{part}}).",
  "v6.exploitation.engagement.incidents": "Incidents of the period",
  "v6.exploitation.engagement.incidents_vide": "No incident over the window: nothing is consumed by an incident.",
  "v6.exploitation.engagement.indicateur.availability": "availability",
  "v6.exploitation.engagement.indicateur.latency": "latency",
  "v6.exploitation.engagement.indicateur_champ": "Indicator",
  "v6.exploitation.engagement.indicateur_env": "Indicator: {{indicateur}} · environment: {{environnement}} (set at declaration).",
  "v6.exploitation.engagement.introuvable": "This commitment cannot be found in this project.",
  "v6.exploitation.engagement.jours": "Window length (days)",
  "v6.exploitation.engagement.jours_aide": "From 1 to 90 days.",
  "v6.exploitation.engagement.jours_invalides": "The window is 1 to 90 days.",
  "v6.exploitation.engagement.marge": "Budget calculation",
  "v6.exploitation.engagement.ne_consomme_pas": "{{statut}} · {{severite}} · not counted (not an outage)",
  "v6.exploitation.engagement.nom": "Name",
  "v6.exploitation.engagement.nom_aide": "At least three characters, unique in the project.",
  "v6.exploitation.engagement.nom_court": "The name has at least three characters.",
  "v6.exploitation.engagement.non_mesuree": "Budget not measured: no data over the window.",
  "v6.exploitation.engagement.objet": "the commitment",
  "v6.exploitation.engagement.resume": "Target {{cible}} · window {{jours}} days · threshold {{seuil}} ms · {{environnement}}",
  "v6.exploitation.engagement.sans_engagement": "No commitment is designated: open it from the commitment list.",
  "v6.exploitation.engagement.sans_environnement": "No environment is declared for this project.",
  "v6.exploitation.engagement.sans_membre": "No member to notify.",
  "v6.exploitation.engagement.seuil": "Latency threshold (ms)",
  "v6.exploitation.engagement.seuil_requis": "Give the latency threshold in milliseconds.",
  "v6.exploitation.engagement.seuils": "Alert thresholds (% of budget consumed)",
  "v6.exploitation.engagement.seuils_a_corriger": "Correct the alert thresholds.",
  "v6.exploitation.engagement.seuils_aide": "For example “50, 80”.",
  "v6.exploitation.engagement.seuils_invalides": "Thresholds from 1 to 100, increasing, separated by commas.",
  "v6.exploitation.engagement.sonde": "{{date}} · {{statut}} · HTTP {{http}} · {{latence}} ms",
  "v6.exploitation.engagement.sondes": "Probe history",
  "v6.exploitation.engagement.sondes_vide": "No probe over the window.",
  "v6.exploitation.engagement.titre": "Service commitment record",
  "v6.exploitation.engagement.version": "Version {{version}} of {{date}}",
  "v6.exploitation.engagements.actif": "active",
  "v6.exploitation.engagements.avertit": "Warning: it signals, it blocks no delivery.",
  "v6.exploitation.engagements.config_manage": "Managing the runtime catalogue requires “Manage configuration”.",
  "v6.exploitation.engagements.declarer": "Declare a commitment",
  "v6.exploitation.engagements.disponibilite": "Availability {{cible}} over {{jours}} days · {{environnement}}",
  "v6.exploitation.engagements.inactif": "inactive",
  "v6.exploitation.engagements.jamais_mesure": "never measured",
  "v6.exploitation.engagements.latence": "Latency ≤ {{seuil}} ms for {{cible}} of probes over {{jours}} days · {{environnement}}",
  "v6.exploitation.engagements.marge": "{{nom}}: {{etat}}, {{consomme}} {{unite}} consumed out of {{total}} ({{part}})",
  "v6.exploitation.engagements.marge_courte": "Budget {{etat}} · {{part}}% consumed",
  "v6.exploitation.engagements.marges": "Budget consumed",
  "v6.exploitation.engagements.marges_vide": "No measured commitment: no budget to show.",
  "v6.exploitation.engagements.mesure_le": "Measured on {{date}}",
  "v6.exploitation.engagements.regler_runtime": "Configure the runtime",
  "v6.exploitation.engagements.runtime": "Runtime catalogue",
  "v6.exploitation.engagements.runtime_actif": "{{cle}} active",
  "v6.exploitation.engagements.runtime_distinct": "Runtime technical objectives, distinct from the business commitments above.",
  "v6.exploitation.engagements.runtime_echec": "Saving the catalogue did not complete.",
  "v6.exploitation.engagements.runtime_enregistrer": "Save the catalogue",
  "v6.exploitation.engagements.runtime_inchange": "No change to save.",
  "v6.exploitation.engagements.runtime_ligne": "target {{cible}} ({{sens}}) over {{minutes}} min · version {{version}}",
  "v6.exploitation.engagements.runtime_ok": "Catalogue saved.",
  "v6.exploitation.engagements.runtime_vide": "No runtime objective in the catalogue.",
  "v6.exploitation.engagements.sens.at_least": "at least",
  "v6.exploitation.engagements.sens.at_most": "at most",
  "v6.exploitation.engagements.titre": "Service commitments",
  "v6.exploitation.engagements.titre_ecran": "Service commitments",
  "v6.exploitation.engagements.unite.minutes": "minutes",
  "v6.exploitation.engagements.unite.probes": "probes",
  "v6.exploitation.engagements.vide": "No service commitment is declared.",
  "v6.exploitation.etat.chargement": "Reading {{quoi}}…",
  "v6.exploitation.etat.en_cours": "In progress…",
  "v6.exploitation.etat.erreur": "{{quoi}}: the read did not complete.",
  "v6.exploitation.etat.introuvable": "{{quoi}}: not found in this project.",
  "v6.exploitation.etat.reessayer": "Retry",
  "v6.exploitation.etat.refus": "{{quoi}}: read refused for your profile.",
  "v6.exploitation.fiche.acteurs": "Owner: {{responsable}} · declared by {{declarant}} · started {{debut}}",
  "v6.exploitation.fiche.action": "Follow-up action",
  "v6.exploitation.fiche.action_ok": "Action added.",
  "v6.exploitation.fiche.action_requise": "Name the follow-up action.",
  "v6.exploitation.fiche.actions": "Follow-up actions",
  "v6.exploitation.fiche.ajouter_action": "Add the action",
  "v6.exploitation.fiche.anomalies": "Defects and follow-up actions",
  "v6.exploitation.fiche.anomalies_vide": "No linked defect.",
  "v6.exploitation.fiche.bilan": "Blameless review",
  "v6.exploitation.fiche.clos": "Incident closed: read only.",
  "v6.exploitation.fiche.consigner": "Record the fact",
  "v6.exploitation.fiche.deploiement": "View the deployment",
  "v6.exploitation.fiche.deploiement_inconnu": "Unknown deployment",
  "v6.exploitation.fiche.duree": "Impact duration: {{duree}}",
  "v6.exploitation.fiche.echec": "The action did not complete.",
  "v6.exploitation.fiche.enregistrer_qualification": "Save the qualification",
  "v6.exploitation.fiche.etat_change": "Incident state changed.",
  "v6.exploitation.fiche.fait": "{{date}} · {{type}} · {{acteur}} {{message}}",
  "v6.exploitation.fiche.fait_champ": "Observed fact",
  "v6.exploitation.fiche.fait_date": "Date of the fact (local time)",
  "v6.exploitation.fiche.fait_date_aide": "Time zone: {{fuseau}}. Empty: now.",
  "v6.exploitation.fiche.fait_ok": "Fact recorded.",
  "v6.exploitation.fiche.fait_requis": "Describe the fact to record.",
  "v6.exploitation.fiche.faits": "Dated facts",
  "v6.exploitation.fiche.faits_vide": "No fact recorded.",
  "v6.exploitation.fiche.incident": "the incident",
  "v6.exploitation.fiche.introuvable": "This incident cannot be found in this project.",
  "v6.exploitation.fiche.marge": "{{nom}}: {{minutes}} min counted, budget consumed {{part}}",
  "v6.exploitation.fiche.motif_requis": "Give the reason for reopening.",
  "v6.exploitation.fiche.numero_anomalie": "Defect number",
  "v6.exploitation.fiche.numero_invalide": "Enter the defect number (digits only).",
  "v6.exploitation.fiche.numero_requis": "Give a valid defect number.",
  "v6.exploitation.fiche.qualification": "Qualification",
  "v6.exploitation.fiche.qualification_ok": "Qualification saved.",
  "v6.exploitation.fiche.relie": "Defect linked.",
  "v6.exploitation.fiche.relier": "Link the defect",
  "v6.exploitation.fiche.resume": "{{statut}} · {{severite}} · {{nature}} · {{environnement}}",
  "v6.exploitation.fiche.retablissement": "Recovery or reason",
  "v6.exploitation.fiche.retablissement_aide": "Resolve: describe the recovery. Reopen: give the reason.",
  "v6.exploitation.fiche.retablissement_requis": "Describe the recovery to resolve.",
  "v6.exploitation.fiche.sans_incident": "No incident is designated: open it from the incident list.",
  "v6.exploitation.fiche.sans_marge": "No commitment counts this incident.",
  "v6.exploitation.fiche.titre": "Incident record",
  "v6.exploitation.fiche.transition_absente": "This action is not possible from the “{{statut}}” state.",
  "v6.exploitation.fiche.transition_refusee": "This state change is refused.",
  "v6.exploitation.fiche.transitions": "Incident state",
  "v6.exploitation.fiche.type.action_created": "Action added",
  "v6.exploitation.fiche.type.declared": "Declared",
  "v6.exploitation.fiche.type.defect_linked": "Defect linked",
  "v6.exploitation.fiche.type.note": "Fact",
  "v6.exploitation.fiche.type.postmortem_published": "Review published",
  "v6.exploitation.fiche.type.postmortem_saved": "Review saved",
  "v6.exploitation.fiche.type.status": "State change",
  "v6.exploitation.fiche.type.updated": "Qualification",
  "v6.exploitation.fiche.version": "Version {{version}}",
  "v6.exploitation.fiche.version_inconnue": "Unknown version",
  "v6.exploitation.incidents.cycle": "An incident is open, then mitigated, resolved and finally closed.",
  "v6.exploitation.incidents.cycle_bilan": "Closing an incident requires its published blameless review.",
  "v6.exploitation.incidents.cycle_titre": "Incident lifecycle",
  "v6.exploitation.incidents.declarer": "Declare an incident",
  "v6.exploitation.incidents.en_cours": "Ongoing (open and mitigated)",
  "v6.exploitation.incidents.filtre_vide": "No incident matches these filters.",
  "v6.exploitation.incidents.ligne": "{{statut}} · {{severite}} · {{nature}} · {{environnement}} · owner {{responsable}} · {{duree}}",
  "v6.exploitation.incidents.liste": "Incident list",
  "v6.exploitation.incidents.severite": "Severity",
  "v6.exploitation.incidents.statut": "Status",
  "v6.exploitation.incidents.titre": "Incidents",
  "v6.exploitation.incidents.tous": "All",
  "v6.exploitation.incidents.toutes": "All",
  "v6.exploitation.incidents.vide": "No ongoing incident in this project.",
  "v6.exploitation.inconnu_explicitement": "unknown (stated)",
  "v6.exploitation.inconnue_explicitement": "unknown (stated)",
  "v6.exploitation.lien.application_en_service": "Application in service",
  "v6.exploitation.lien.engagements": "Service commitments",
  "v6.exploitation.lien.incidents": "Incidents",
  "v6.exploitation.lien.retour_incident": "Back to the incident",
  "v6.exploitation.lien.retour_supervision": "Back to monitoring",
  "v6.exploitation.lien.supervision": "Application monitoring",
  "v6.exploitation.mise.actualiser": "Refresh",
  "v6.exploitation.mise.cible": "Launched target",
  "v6.exploitation.mise.cible_non_remplacee": "The received target is tracked as is, never replaced by the environment’s latest deployment.",
  "v6.exploitation.mise.cible_observee": "Target version {{version}} observed.",
  "v6.exploitation.mise.cible_recue": "Deployment {{deploiement}} · version {{version}} · revision {{revision}} · {{environnement}}",
  "v6.exploitation.mise.confirmee": "Go-live confirmed: {{version}} observed by a probe dated {{date}}.",
  "v6.exploitation.mise.declaration_humaine": "Outcome declared by a person (traced “manual”).",
  "v6.exploitation.mise.non_confirmee": "Go-live not confirmed: no dated evidence observes the target version yet.",
  "v6.exploitation.mise.observe": "Observed service",
  "v6.exploitation.mise.precedente": "The previous version {{version}} is still in service.",
  "v6.exploitation.mise.preuve_worker": "Outcome proven by the worker.",
  "v6.exploitation.mise.progression": "Progress",
  "v6.exploitation.mise.sans_deploiement": "No deployment is designated: open this tracking from a go-live launch.",
  "v6.exploitation.mise.sans_issue": "No outcome yet.",
  "v6.exploitation.mise.sante_non_mesuree": "Health not measured: no dated probe.",
  "v6.exploitation.mise.service_env": "Environment service",
  "v6.exploitation.mise.sonde_echec": "Probe failing: HTTP {{http}} on {{date}}.",
  "v6.exploitation.mise.statut.echoue": "Deployment failed.",
  "v6.exploitation.mise.statut.en_cours": "Deployment in progress.",
  "v6.exploitation.mise.statut.lancement_accepte": "Launch accepted: waiting for the worker.",
  "v6.exploitation.mise.statut.reussi": "Deployment succeeded.",
  "v6.exploitation.mise.statut.suivi_interrompu": "Tracking interrupted: state unknown.",
  "v6.exploitation.mise.titre": "Go-live tracking",
  "v6.exploitation.mise.trace": "Full trace",
  "v6.exploitation.sans_projet": "Choose a project first: operations belong to a project’s application.",
  "v6.exploitation.service.adresse_inconnue": "Application address unknown.",
  "v6.exploitation.service.aucun_service": "No version has been put in service on this environment yet.",
  "v6.exploitation.service.comprendre": "Understand and request",
  "v6.exploitation.service.comprendre_aide": "Request the “Deploy” right on this project, with this environment in context.",
  "v6.exploitation.service.continuite": "Continuity",
  "v6.exploitation.service.deploiements": "the project’s deployments",
  "v6.exploitation.service.dernier_evenement": "Last event: {{date}}",
  "v6.exploitation.service.derniere_sauvegarde": "Last successful backup: {{date}}",
  "v6.exploitation.service.document_livre": "Delivered document",
  "v6.exploitation.service.en_cours": "Deployment of version {{version}} in progress: not in service yet.",
  "v6.exploitation.service.en_service": "Version in service: {{version}} (since {{date}})",
  "v6.exploitation.service.etat.en_echec": "Failing: the last dated probe failed.",
  "v6.exploitation.service.etat.non_configuree": "Health not configured: no probe is declared.",
  "v6.exploitation.service.etat.non_mesuree": "Health not measured: no dated probe on this environment.",
  "v6.exploitation.service.etat.saine": "Healthy: the last dated probe is healthy.",
  "v6.exploitation.service.marge_epuisee": "Budget exhausted: warning, nothing is blocked.",
  "v6.exploitation.service.marge_presque": "Budget nearly exhausted.",
  "v6.exploitation.service.mesure": "Measured {{date}} · HTTP {{http}} · {{latence}} ms",
  "v6.exploitation.service.ouverture_externe": "Opens in a new tab, without going through the platform.",
  "v6.exploitation.service.ouvrir": "Open the application",
  "v6.exploitation.service.revenir": "Return to a version",
  "v6.exploitation.service.revenir_impossible": "Returning to a version requires an effective deployment on this environment.",
  "v6.exploitation.service.rpo_rto": "Observed RPO {{rpo}} min (target {{rpo_cible}}) · observed RTO {{rto}} min (target {{rto_cible}})",
  "v6.exploitation.service.sans_cible_recette": "No expected acceptance target: nothing to compare.",
  "v6.exploitation.service.sans_environnement": "No environment is designated: open this service from monitoring or the application in service.",
  "v6.exploitation.service.sante": "the environment’s health",
  "v6.exploitation.service.sante_titre": "Health and budget",
  "v6.exploitation.service.sauvegarde_absente": "No backup is configured.",
  "v6.exploitation.service.sauvegarde_non_mesuree": "Backup not measured.",
  "v6.exploitation.service.titre": "Environment service",
  "v6.exploitation.service.version_titre": "Version in service",
  "v6.exploitation.service.voir_version": "View the version",
  "v6.exploitation.supervision.aucune_mesure": "No dated measurement.",
  "v6.exploitation.supervision.contexte_conserve": "Environment, version and measurement passed on.",
  "v6.exploitation.supervision.contexte_partiel": "Version or measurement unknown: they will have to be filled in.",
  "v6.exploitation.supervision.declarer_sur": "Declare an incident on {{environnement}}",
  "v6.exploitation.supervision.derniere_mesure": "Last measurement: {{date}} · HTTP {{http}} · {{latence}} ms",
  "v6.exploitation.supervision.environnements": "Environment health",
  "v6.exploitation.supervision.incidents_ouverts": "{{n}} open incident(s)",
  "v6.exploitation.supervision.jamais_sondee": "never probed",
  "v6.exploitation.supervision.service": "Environment service",
  "v6.exploitation.supervision.sondes": "Healthy probes: {{saines}} / {{total}} over {{jours}} days",
  "v6.exploitation.supervision.source.program": "Measurements of the programme’s shared environment",
  "v6.exploitation.supervision.source.project": "Project measurements",
  "v6.exploitation.supervision.titre": "Application monitoring",
  "v6.exploitation.supervision.version": "Observed version: {{version}} (deployed {{date}})",
  "v6.exploitation.supervision.version_inconnue": "Version in service unknown",
  "v6.exploitation.supervision.vide": "No environment is declared for this project."
}
